import { render, staticRenderFns } from "./ThePageWrapper.vue?vue&type=template&id=1808391b"
import script from "./ThePageWrapper.vue?vue&type=script&lang=js"
export * from "./ThePageWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports